import {
    Box,
    Card,
    CardHeader,
    Tabs,
    Tab,
    CardContent,
    CardActions,
    Button,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography
} from '@mui/material';
import React from 'react';
import { VehicleProfileDetails } from './VehicleProfileDetails'
import _ from 'lodash'
import CustomAlert from '../../components/CustomAlert';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


let defaultProfile = {
    "description": "",
    "make": "",
    "model": "",
    "externalId": "",
    "weightInLbs": 0,
    "vehicleHeight": {
        "inches": 0,
        "feet": 0
    },
    "vehicleWidth": {
        "inches": 0,
        "feet": 0
    },
    "type": "",
    "isNew": true
}

const VehicleProfileSelection = (props) => {
    const setSelectedProfile = props.setSelectedProfile;
    const setOriginalProfile = props.setOriginalProfile;
    const originalProfile = props.originalProfile;
    const profiles = props.profiles;
    const setIsNew = props.setIsNew;
    const setLoading = props.setLoading;
    const setIsDelete = props.setIsDelete;
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));

    const setProfileFromName = (event) => {
        const name = event.target.value;
        const profile = profiles.find(p => p.externalId === name);
        setOriginalProfile((_.cloneDeep(profile)));
    }

    React.useEffect(() => {
        setSelectedProfile((_.cloneDeep(originalProfile)));
        setLoading(false);
    }, [originalProfile])

    return (
        <Box sx={{ paddingTop: 3 }}>
            <FormControl sx={{ width: "70%" }}>
                <InputLabel id="select-label">Select a Vehicle</InputLabel>
                <Select
                    labelId="select-label"
                    id="simple-select"
                    label="Select a Vehicle"
                    onChange={setProfileFromName}
                    value=""
                >
                    {profiles.map(profile => {
                        return <MenuItem value={profile.externalId} key={profile.externalId}>{profile.externalId}</MenuItem>
                    })}
                </Select>
            </FormControl>
            <Button color="primary" sx={matches ? { marginLeft: 3, marginTop: 1 } : { marginTop: 1 }} onClick={() => { setIsNew(true) }}
                variant="contained">ADD</Button>
            <Button color="primary" sx={matches ? { marginLeft: 3, marginTop: 1 } : { marginTop: 1, marginLeft: 1 }} onClick={() => { setIsDelete(true) }}
                variant="contained" disabled={null === originalProfile}>Delete</Button>
        </Box>
    )
}


export const VehicleProfileComponent = (props) => {
    const [editedProfile, setEditedProfile] = React.useState(false);
    const [selectedProfile, setSelectedProfile] = React.useState(null);
    const [originalProfile, setOriginalProfile] = React.useState(null);
    const [isSaving, setIsSaving] = React.useState(false);
    const [isNew, setIsNew] = React.useState(false);
    const [isDelete, setIsDelete] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const setIsUser = props.setIsUser;
    const setFooterSelection = props.setFooterSelection;
    const user = props.user;
    const profiles = user?.extVehicles;
    const setRefreshUser = props.setRefreshUser;

    const [showAlert, setShowAlert] = React.useState(false);
    const [message, setMessage] = React.useState("")
    const [severity, setSeverity] = React.useState("success");

    React.useEffect(() => {
        if ("" !== message) {
            setShowAlert(true);
        }
    }, [message])

    React.useEffect(() => {
        if (!showAlert) {
            setMessage("");
        }
    }, [showAlert])

    React.useEffect(() => {
        setIsUser(true);
        setFooterSelection(2);
    }, [])

    React.useEffect(() => {
        if (isNew) {
            setSelectedProfile(_.cloneDeep(defaultProfile));
            setOriginalProfile(_.cloneDeep(defaultProfile));
            setIsNew(false);
            setLoading(false);
        }
    }, [isNew, defaultProfile]);

    React.useEffect(() => {
        if (user) {
            setIsNew(user.extVehicles.length === 0)
        }
    }, [])

    React.useEffect(() => {
        if (user) {
            setIsNew(user.extVehicles.length === 0)
        }
    }, [user])

    const checkValidNumber = (field) => {
        return field !== 0 && field !== "";
    }

    React.useEffect(() => {
        if (!loading && selectedProfile) {
            let isEdited = !_.isEqual(selectedProfile, originalProfile);
            let requiredFieldsValid = selectedProfile.description !== "" && selectedProfile.externalId !== "" && selectedProfile.type !== "";
            let numberFieldsValid = checkValidNumber(selectedProfile.vehicleHeight.feet) && checkValidNumber(selectedProfile.vehicleWidth.feet) && checkValidNumber(selectedProfile.weightInLbs);
            let inchFieldsValid = selectedProfile.vehicleHeight.inches !== "" && selectedProfile.vehicleWidth.inches !== "";
            setEditedProfile (isEdited && requiredFieldsValid && numberFieldsValid && inchFieldsValid);
        }
    }, [selectedProfile, originalProfile, loading])

    const saveProfile = async (selectedProfile) => {
        delete (selectedProfile.isNew);
        const response = await fetch(process.env.REACT_APP_API_HOST + "/account/update/vehicle", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(selectedProfile)
        })
        const ret = await response.json();
        if (ret.success) {
            setMessage("Vehicle Updated");
            setOriginalProfile(_.cloneDeep(selectedProfile));
            setIsSaving(false);
            setRefreshUser(true);
        } else {
            setMessage("Profile Update Failed")
        }
    }

    React.useEffect(() => {
        if (isDelete) {
            const deleteProfile = async (selectedProfile) => {
                const response = await fetch(process.env.REACT_APP_API_HOST + "/account/delete/vehicle", {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(selectedProfile)
                })
                const ret = await response.json();
                if (ret.success) {
                    setMessage("Vehicle Deleted");
                    setOriginalProfile(null);
                    setIsDelete(false);
                    setRefreshUser(true);
                } else {
                    setMessage("Profile Delete Failed")
                }
            }
            deleteProfile(selectedProfile);
        }
    }, [isDelete, selectedProfile])

    const resetProfile = () => {
        setSelectedProfile(_.cloneDeep(originalProfile));
    }

    return (
        <>
            <CustomAlert showAlert={showAlert} message={message} severity={severity} setShowAlert={setShowAlert} setMessage={setMessage} />
            <Box component="div" sx={{
                height: "calc(100vh - 160px)",
                width: "100%",
                overflow: "auto",
                padding: 2
            }}>
                <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
                    Vehicles
                </Typography>
                <Typography color="textSecondary"
                    variant="subtitle">
                    Enter details about your vehicles for routing directions which include road and street restrictions based on vehicle weight and height.
                </Typography>
                {profiles && profiles.length > 0 ?
                    <Card>
                        <CardContent>
                            <VehicleProfileSelection setSelectedProfile={setSelectedProfile} selectedProfile={selectedProfile} profiles={profiles}
                                setOriginalProfile={setOriginalProfile} setIsNew={setIsNew} originalProfile={originalProfile} setLoading={setLoading} setIsDelete={setIsDelete} />
                        </CardContent>
                    </Card> : null
                }

                {selectedProfile ? <VehicleProfileDetails selectedProfile={selectedProfile} isNew={isNew} setSelectedProfile={setSelectedProfile} editedProfile={editedProfile} resetProfile={resetProfile} saveProfile={saveProfile} /> : null}
            </Box>
        </>
    )
};